import * as React from "react";

import { Helmet } from "react-helmet-async";

import "../styles/home.css";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Snigdha &amp; Sushain</title>
      </Helmet>
      <div className="home-container w-100 h-100" />
    </>
  );
};

export default Home;
